'use client';
import React from 'react';

export default function SellOnMdeliva() {
  return (
    <section className="py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div
          className="rounded-2xl p-8 border"
          style={{
            background: 'linear-gradient(135deg, #1a0e00 0%, #0d0700 100%)',
            borderColor: '#2d1a00',
          }}
        >
          {/* Logo/Icon */}
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" rx="4"/>
                <text x="3" y="17" fontSize="14" fontWeight="bold" fill="#1a56db">M</text>
              </svg>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
            Sell on Mdeliva
          </h2>
          <p className="text-gray-400 text-sm mb-6 max-w-lg">
            Join 1,200+ vendors already growing their business with Mdeliva. Set up your shop in minutes, keep 85% of every order. Full dashboard, analytics, and payment tools included.
          </p>

          <div className="flex flex-wrap gap-3">
            <button
              className="flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white text-sm transition-all duration-200 hover:scale-105"
              style={{ background: 'linear-gradient(135deg, #f97316, #ea6c00)' }}
            >
              Become a vendor →
            </button>
            <button className="flex items-center gap-2 px-6 py-3 rounded-full font-medium text-white text-sm bg-[#1e1e1e] border border-[#333] hover:bg-[#2a2a2a] transition-all duration-200">
              Preview dashboard
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
